/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Lot_Section_HintInputs */

const vi_pos_lot_section_hint = /** @type {(inputs: Pos_Lot_Section_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hệ thống gợi ý lô nhập trước xuất trước, đổi lô nếu khách lấy lô khác trên kệ.`)
};

/**

* @param {Pos_Lot_Section_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_lot_section_hint = /** @type {((inputs?: Pos_Lot_Section_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Lot_Section_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_lot_section_hint(inputs)
});